module.exports = __webpack_public_path__ + "img/parallelLogoReverse.7301dd9c.png";